import {
  Action,
  ActionCreator
} from 'redux';
import { PermissionTypes } from '@iv/store/permissions/permissions.models';

export const ADD_PERMISSIONS = '[Permissions] add Permissions';

export interface AddPermissionsAction extends Action {
  permissions: PermissionTypes[];
}

export const addPermission: ActionCreator<AddPermissionsAction> = (permissions): AddPermissionsAction => {
  return {
    type: ADD_PERMISSIONS,
    permissions: permissions
  };
};
